import React from "react"
import { FaTrashAlt } from "react-icons/fa"
import { useTranslation } from "react-i18next"

import { Tooltip } from "components"
import { productUnitsSymbol } from "constant"
import { formatMobilePhone, moment, thousandSeparator } from "utils"
import classes from "./RmTableRow.module.scss"

const RmTableRow = (props) => {
  const {
    eoIndex,
    orderForDispatch,
    setOrdersForDispatch
  } = props

  const [t] = useTranslation()

  const handleDelete = () => {
    setOrdersForDispatch(prev =>
      prev.filter(od =>
        od._id !== orderForDispatch._id
      )
    )
  }

  return (
    <tr className={classes["table-row"]}>
      <td>
        {eoIndex + 1}
      </td>
      <td>
        {orderForDispatch.customerFullName || t("بدون_نام")}
        <br />
        {formatMobilePhone(orderForDispatch.customerMobilePhone)}
      </td>
      <td>
        {orderForDispatch.code}
      </td>
      <td>
        {moment(orderForDispatch.date).format("jYYYY/jMM/jDD")}
        <br />
        {moment(orderForDispatch.date).format("HH:mm")}
      </td>
      <td>
        {moment(orderForDispatch.paymentDate).format("jYYYY/jMM/jDD")}
        <br />
        {moment(orderForDispatch.paymentDate).format("HH:mm")}
      </td>
      <td>
        <table className={classes["table"]}>
          <tbody>
            {orderForDispatch.items.map((item, itemIndex) =>
              <tr key={itemIndex}>
                <td>{item.quantity}{t(productUnitsSymbol[item.unit])}</td>
                <td className={classes["name"]}>
                  {item.foodName}{item.isSimple ? "" : ` - ${item.option.name}`}{item.sku ? ` - ${item.sku}` : ""}
                </td>
                <td>{item.foodCode}</td>
              </tr>
            )}
          </tbody>
        </table>
      </td>
      <td>
        {orderForDispatch.isDispatched ? t("خروج_از_انبار") : t("خروج_نخورده")}
        <br />
        {t("پرداخت_شده")}
      </td>
      <td>
        {orderForDispatch.addedBySystem ? orderForDispatch.addedByFullName : t("سایت")}
      </td>
      <td>
        {thousandSeparator(orderForDispatch.totalBillAmount)}
      </td>
      <td>
        <Tooltip title={t("حذف_سفارش")}>
          <button
            onClick={handleDelete}
          >
            <FaTrashAlt
              size={17}
              color="var(--color-danger)"
            />
          </button>
        </Tooltip>
      </td>
    </tr>
  )
}

export default React.memo(RmTableRow)